import { Row, Col } from 'reactstrap';
import SvgRender from 'common/components/general/SvgRender';
import { Link } from 'react-router-dom';
import paths from 'routing/routes/_paths';

import { useSelector } from 'react-redux';

import auth from 'assets/svg/navbar/auth.svg';
import companies from 'assets/svg/navbar/companies.svg';
import enums from 'assets/svg/navbar/enums.svg';
import indexes from 'assets/svg/navbar/indexes.svg';
import integrations from 'assets/svg/navbar/integrations.svg';
import routes from 'assets/svg/navbar/routes.svg';
import users from 'assets/svg/navbar/users.svg';
import reports from 'assets/svg/navbar/reports.svg';
import beacon from 'common/assets/svg/common/beacon.svg';
import aiSpark from 'common/assets/svg/common/ai-spark.svg';
import setup from 'common/assets/svg/common/setup.svg';

const Landing = () => {
  const account = useSelector(state => state.account);

  const landingRoutes = [
    { label: 'companies', name: 'Companies', icon: companies, path: paths.companies },
    { label: 'enums', name: 'Enums', icon: enums, path: paths.enums.cargo },
    { label: 'indexes', name: 'Indexes', icon: indexes, path: paths.indexes },
    {
      label: 'integrations',
      name: 'Integrations',
      icon: integrations,
      path: `${paths.integrations}/logs`
    },
    { label: 'users', name: 'Users', icon: users, path: paths.users },
    { label: 'routes', name: 'Routes', icon: routes, path: paths.routes },
    { label: 'reports', name: 'Reports', icon: reports, path: paths.reports },
    { label: 'beacon', name: 'Beacon', icon: beacon, path: paths.beacon },
    { label: 'authorization', name: 'Authorization', icon: auth, path: paths.authorization },
    { label: 'ai_logs', name: 'AI Logs', icon: aiSpark, path: paths.ai_logs },
    {
      label: 'company_settings',
      name: 'Company Settings',
      icon: setup,
      path: paths.company_settings
    }
  ];

  return (
    <div className="landing-page d-flex align-items-center justify-content-center flex-column">
      <div className="landing-page--content">
        <h1>
          <span className="fw-light">Hello,</span> <br />
          {account && account.name ? <strong>{account.name}</strong> : ''}
        </h1>
        <Row className="landing-routes-wrapper no-gutters">
          {landingRoutes.map(route => (
            <Col xs={4} key={route.label} className={`landing-route route-${route.label}`}>
              <Link to={route.path} className="d-flex justify-content-end w-100p h-100p">
                <div className="landing-route--icon">
                  <SvgRender src={route.icon} style={{ width: 32, height: 32 }} />
                </div>
                <div className="landing-route--label mt-auto">{route.name}</div>
              </Link>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default Landing;
